<p-modal [open]="!!modal.state()" [size]="size()" (closed)="onClosed()">
  <div slot="header" class="p-flex-row-sm p-flex-between p-flex-center-y">
    <div class="p-flex p-flex-col">
      @if (modal.state() === 'refine') {
      <div class="p-flex-row-xxxs p-flex-center-y">
        <span class="p-text-title-sm">Refine:</span>
        <p-inline-input
          placeholder="Enter a name"
          class="p-text-title-sm"
          [text]="modal.corpus()?.corpusName ?? ''"
          (textChange)="refine()?.nameChanged($event)"
        />
      </div>
      } @else if (modal.state() === 'format') {
      <span class="p-text-title-sm">Format: {{ modal.corpus()?.corpusName ?? '' }}</span>
      } @else if (modal.state() === 'action') {
      <span class="p-text-title-sm">{{ modal.corpus()?.corpusName ?? '' }}</span>
      } @else if (modal.state() === 'upload') {
      <span class="p-text-title-sm">{{ title() }}</span>
      <span class="p-text-body p-color-text-tertiary">{{ subtitle() }}</span>
      }
    </div>
    @if (modal.state() === 'refine') {
    <div class="p-flex-row-xs">
      <p-button-icon-secondary-lg
        icon="copy"
        aria-label="Save a copy"
        [disabled]="!modal.corpus()"
        [loading]="refine()?.isDeriving ?? false"
        (click)="refine()?.deriveCorpus()"
      />
      <p-button-icon-secondary-lg
        icon="download"
        aria-label="Download data"
        [disabled]="!modal.corpus()"
        [loading]="refine()?.isDownloading ?? false"
        (click)="refine()?.downloadCorpusData()"
      />
    </div>
    } @else if (modal.state() === 'format') {
    <div class="p-flex-row-xs">
      <p-button-icon-secondary-lg
        icon="copy"
        aria-label="Save a copy"
        [disabled]="!modal.corpus()"
        [loading]="isDeriving"
        (click)="deriveCorpus()"
      />
      <p-button-icon-secondary-lg
        icon="download"
        aria-label="Download data"
        [disabled]="!modal.corpus()"
        [loading]="isDownloading"
        (click)="downloadCorpus()"
      />
    </div>
    } @else if (modal.state() === 'action') {
    <div class="p-flex-row-xs p-flex-center-y">
      <p-button-icon-secondary-lg
        icon="copy"
        aria-label="Save a copy"
        [disabled]="!modal.corpus()"
        [loading]="isDeriving"
        (click)="deriveCorpus()"
      />
      <p-button-icon-secondary-lg
        icon="download"
        aria-label="Download formatted data"
        [disabled]="!(action()?.canDownload() ?? false)"
        [loading]="action()?.isDownloading ?? false"
        (click)="action()?.download()"
      />
    </div>
    }
  </div>
  @switch (modal.state()) { @case ('upload') {
  <app-ingest-modal-upload (selectedCorpusId)="onCorpusSelected($event)" />
  } @case ('refine') { @if (modal.corpus(); as corpus) {
  <app-ingest-modal-refine
    [corpusId]="corpus.id"
    (corpusIdChange)="onCorpusDerived($event)"
    (corpusChange)="modal.corpus.set($event)"
    (formatRequested)="onRefined()"
    (back)="onClosed()"
  />
  } } @case ('format') { @if (modal.corpus(); as corpus) {
  <app-ingest-modal-format
    [corpusId]="corpus.id"
    [pifId]="modal.pif()?.id"
    (formatted)="onFormatted($event)"
    (back)="modal.openRefine(corpus.id)"
  />
  } } @case ('action') { @if (modal.corpus(); as corpus) { @if (modal.pif(); as pif) {
  <app-ingest-modal-action [corpusId]="corpus.id" [pifId]="pif.id" (closed)="onClosed()" />
  } } } } @if(modal.state() === 'upload') {
  <div slot="footer" class="p-flex p-flex-end">
    <div class="p-flex-row-xs">
      <p-button-secondary (click)="onClosed()">Cancel</p-button-secondary>
    </div>
  </div>
  } @else if (modal.state() === 'action') {
  <div slot="footer" class="p-flex p-flex-end">
    <div class="p-flex-row-xs">
      <p-button-ghosted (click)="onClosed()">Skip for now</p-button-ghosted>
      <p-button-secondary (click)="modal.openFormat(modal.corpus()!.id, modal.pif()?.id)">
        <p-icon-lg icon="refresh" />Back to formatting
      </p-button-secondary>
    </div>
  </div>
  }
</p-modal>
